import React from 'react'
import { DragDropContext, Droppable } from '@hello-pangea/dnd'

const moveItemAndRenumberPositions = (list, from, to) => {
  const result = [...list]
  const [moved] = result.splice(from, 1)
  result.splice(to, 0, moved)
  return result.map((item, index) => ({ ...item, position: index + 1 }))
}

const DropContainer = ({ children, updatePositions, collection, direction }) => {
  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return
    }

    let items = moveItemAndRenumberPositions(collection, result.source.index, result.destination.index)
    updatePositions(items)
  }


  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable" direction='vertical'>
        {(dropabbleProvided, snapshot) => (
          <div
            {...dropabbleProvided.droppableProps}
            ref={dropabbleProvided.innerRef}>
            {children}
            {dropabbleProvided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}

export { DropContainer }
